import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "menu"]

  connect() {
    this.outsideClickListener = (event) => {
      if (!this.element.contains(event.target) && this.hasMenuTarget) {
        this.menuTarget.classList.remove("show")
      }
    }
    document.addEventListener("click", this.outsideClickListener)
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClickListener)
  }

  toggle(event) {
    event.stopPropagation()
    if (this.hasMenuTarget) {
      this.menuTarget.classList.toggle("show")
    }
  }

  close() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.remove("show")
    }
  }
}
